module.exports = __webpack_public_path__ + "img/country-of-residence.a157f90b.svg";